import { forwardRef } from 'react'
import cx from 'classnames'

import { Text } from '@cinch-labs/design-system'

import styles from './find-vehicle-results-count.module.css'
import skeletonStyles from './skeleton.module.css'

export interface FindVehicleResultsCountProps {
  fetchStatus: boolean
  searchResultsCount: number
  pageItemsRange: {
    start: number
    end: number
  }
}

const FindVehicleResultsCount: React.ForwardRefRenderFunction<
  HTMLSpanElement,
  FindVehicleResultsCountProps
> = ({ searchResultsCount, pageItemsRange, fetchStatus }, ref) => {
  const isLoading = fetchStatus
  const { start, end } = pageItemsRange
  const startCount = start.toLocaleString()
  const endCount = end.toLocaleString()
  const resultsCount = searchResultsCount.toLocaleString()

  const setResultsText = () => {
    if (searchResultsCount === 0) {
      return null
    }

    if (searchResultsCount === 1) {
      return '1 result'
    }

    return `${startCount} to ${endCount} of ${resultsCount} results`
  }

  return (
    <Text
      element="span"
      fontSizeFixed="m"
      className={cx(styles['findVehicleResults'], {
        [skeletonStyles['inline']]: isLoading,
        [skeletonStyles['skeleton']]: isLoading,
      })}
      id="results-count"
      aria-live="polite"
      data-testid="results-count"
    >
      <span ref={ref}>{setResultsText()}</span>
    </Text>
  )
}

export default forwardRef(FindVehicleResultsCount)
